import { ScoringSystemEnum } from '~/apis/ssf';

export const scoringSystemOptions = [
  'IPFGL',
  'IPFGL_MALE',
  'IPF',
  'IPF_MALE',
  'WILKS',
  'WILKS_MALE',
  'DOTS',
  'DOTS_MALE',
];

export function scoringSystemNameToLabel(name: ScoringSystemEnum) {
  return {
    IPFGL: 'IPF GL',
    IPFGL_MALE: 'IPF GL Herr',
    IPF: 'IPF',
    IPF_MALE: 'IPF Herr',
    WILKS: 'Wilks',
    WILKS_MALE: 'Wilks Herr',
    DOTS: 'Dots',
    DOTS_MALE: 'Dots Herr',
  }[name];
}
